<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Novo Recurso Pessoal</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form id="formCadastroRecursoPessoal" ref="formCadastroRecursoPessoal" v-model="valid" lazy-validation>
                    <v-row>
                        <v-col cols="12" sm="2" md="2">
                            <v-text-field v-model="item.id" label="Código" readonly dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                            <v-select v-model="item.tipo" label="Tipo" :items="tipos" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="7" md="8">
                            <v-text-field v-model="item.nome" label="Nome" :rules="fieldRules" :counter="255" maxlength="255" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="4" md="2">
                            <v-select v-model="item.sexo" label="Sexo" :items="sexos" item-value="key" item-text="value" :rules="fieldRules" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="4" md="5">
                            <v-text-field v-model="item.cpfCnpj" :label="lblCpfCnpj" :rules="fieldRules" v-mask="mskCpfCnpj" counter="18" maxlength="18" @blur="item.cpfCnpj = (item.cpfCnpj || '').toLocaleUpperCase()" @change="VerificarExistente()" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="4" md="5">
                            <v-text-field v-model="item.identidadeInscricaoEstadual" :label="lblIdentidadeInscricaoEstadual" :counter="15" maxlength="15" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-select v-model="item.etnia" label="Etnia/Cor" :items="etnias" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-select v-model="item.escolaridade" label="Escolaridade" :items="escolaridades" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="4" md="2">
                            <v-text-field v-model="item.cep" label="CEP" v-mask="mskCep" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="8" md="6">
                            <v-text-field v-model="item.logradouro" label="Logradouro" :counter="80" maxlength="80" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="item.bairro" label="Bairro" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="item.cidade" label="Cidade" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-select v-model="item.estado" label="Estado" :items="estados" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="item.pais" label="País" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="3">
                            <v-select v-model="item.tipoRegime" label="Vínculo" :items="tipoRegimes" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-text-field v-model="item.pis" label="PIS" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-text-field v-model="item.telefone" label="Telefone" v-mask="mskTelefone" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-text-field v-model="item.celular" label="Celular" v-mask="mskTelefone" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="item.cargo" label="Cargo" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="item.email" label="E-mail" :counter="60" maxlength="60" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="3">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.dataNascimentoFundacao" :label="lblNascimentoFundacao" :rules="fieldRules" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.dataNascimentoFundacao" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.dataAdesao" label="Data Adesão" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.dataAdesao" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.dataSaida" label="Data Saída" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.dataSaida" no-title/>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-switch style="margin-top: 5px" v-model="item.ativo" label="Ativo" readonly dense/>
                        </v-col>
                        
                        <v-col cols="12" sm="6" md="2">
                            <v-text-field v-model="item.inss" label="INSS" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="item.nomeBanco" label="Nome do Banco" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-text-field v-model="item.agencia" label="Agência" :counter="15" maxlength="15" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-text-field v-model="item.contaCorrente" label="Conta Corrente" :counter="15" maxlength="15" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-textarea v-model="item.observacao" label="Observação" :counter="255" maxlength="255" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="4" v-if="parametro.pessoalCampo01">
                            <v-text-field v-model="item.campo01" :label="parametro.pessoalCampo01" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="4" v-if="parametro.pessoalCampo02">
                            <v-text-field v-model="item.campo02" :label="parametro.pessoalCampo02" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                        <v-col cols="12" sm="4" v-if="parametro.pessoalCampo03">
                            <v-text-field v-model="item.campo03" :label="parametro.pessoalCampo03" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>
<script>
import { MskCpf, MskCnpjAlfa, MskTelefone, MskCep } from '@/core/domain/shared/Global';
import {PessoalService} from '../../../core/services/projetos';
import {Pessoal} from '../../../core/domain/projetos';
import {EstadoEnumService, TipoPessoaEnumService, TipoRegimeEnumService, EtniaEnumService, SexoEnumService, EscolaridadeEnumService, ParametroService} from '../../../core/services/geral';
import Parametro from '../../../core/domain/geral/Parametro';

export default {
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        item: function() { 
            this.item.empresaId = this.sessionApp.empresaId;

            if ('formCadastroRecursoPessoal' in this.$refs)
                this.$refs.formCadastroRecursoPessoal.resetValidation();
        },
        value: function() {
            this.dialog = this.value;
        },
        dialog:  function() {
            if (!this.dialog) {
                this.$emit('fechou');
            }
        },
        'item.tipo': {
            handler: function (val) {
                if (val === 0){
                    this.mskCpfCnpj = MskCpf;
                    this.lblCpfCnpj = 'CPF';
                    this.lblIdentidadeInscricaoEstadual = 'Identidade';
                    this.lblNascimentoFundacao = 'Nascimento';
                }
                else {
                    this.mskCpfCnpj = MskCnpjAlfa;
                    this.lblCpfCnpj = 'CNPJ';
                    this.lblIdentidadeInscricaoEstadual = 'Inscrição Estadual';
                    this.lblNascimentoFundacao = 'Fundação';
                }

            },
            deep: true
        },
    },
    data: () => ({
        service: new PessoalService(),
        mskCpfCnpj: MskCpf,
        mskTelefone: MskTelefone,
        mskCep: MskCep,
        lblCpfCnpj: 'CPF',
        lblIdentidadeInscricaoEstadual: 'Identidade',
        lblNascimentoFundacao: 'Nascimento',
        valid: true,
        dialog: false,
        isLoading: false,
        tipos: [],
        estados: [],
        etnias: [],
        escolaridades: [],
        sexos: [],
        tipoRegimes: [],
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        sessionApp: {},
        salvando: false,
        parametro: new Parametro()
    }),
    methods: {
        VerificarExistente(){
            this.service.VerificarExistente(this.item.cpfCnpj).then(
                res => {
                    let resposta = res.data;
                    if(resposta){
                        this.item.cpfCnpj = "";
                        this.$swal('Aviso', "Já existe um Recurso Pessoal com esse CPF/CNPJ cadastrado.", 'warning')
                    }
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            )
        },
        save() {

            if (this.$refs.formCadastroRecursoPessoal.validate()) {

                this.salvando = true;

                let modelo = new Pessoal(this.item);

                this.service.Salvar(modelo).then(
                    res => {
                        this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                        this.$emit('salvou');
                        this.close();

                    }, 
                    err =>  {
                        if (err.response.status == 400) {
                            this.$swal('Aviso', err.response.data.title, 'warning')    
                        }
                        else {
                            this.$swal('Aviso', err.response.data, 'error')
                        }
                    }
                ).finally(() => {
                    this.salvando = false;
                })
            }

        },
        close() {
            this.dialog = false;
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {

        this.sessionApp = JSON.parse(localStorage.sessionApp);
        
        let tipoEnumService = new TipoPessoaEnumService();
        tipoEnumService.Listar()
            .then(
                res => {
                    this.tipos = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );

        let estadoEnumService = new EstadoEnumService();
        estadoEnumService.Listar()
            .then(
                res => {
                    this.estados = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );

        let tipoRegimenumService = new TipoRegimeEnumService();
        tipoRegimenumService.Listar()
            .then(
                res => {
                    this.tipoRegimes = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );

        let etnianumService = new EtniaEnumService();
        etnianumService.Listar()
            .then(
                res => {
                    this.etnias = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );

        let sexonumService = new SexoEnumService();
        sexonumService.Listar()
            .then(
                res => {
                    this.sexos = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );

        let escolaridadeEnumService = new EscolaridadeEnumService();
        escolaridadeEnumService.Listar()
            .then(
                res => {
                    this.escolaridades = res.data;
                },
                err => this.$swal('Aviso', err.message, 'error')
            )
        let parametroService = new ParametroService();
        parametroService.ObterPorId(1).then(
            res => {
                this.parametro = new Parametro(res.data);
            },
            err => this.$swal('Aviso', err.message, 'error')
        )
    }
}
</script>
